<template>
  <b-modal
      :visible="visible"
      id="admin-non-metrc-browse-group-modal"
      :title="isEdit ? 'Edit Browse Group' : 'Add Browse Group'"
      @hidden="$emit('cancel')"
      hide-footer
      centered
  >
    <b-form @submit.prevent="submitForm">
      <b-form-group label="Strategy Key">
        <b-form-input
            v-model.trim="formData.strategy_key"
            type="text"
            disabled
            :state="fieldValid('strategy_key')"
        />
        <b-form-invalid-feedback :state="fieldValid('strategy_key')">
          {{ formValidation.strategy_key }}
        </b-form-invalid-feedback>
      </b-form-group>

      <b-form-group label="Group Key">
        <b-form-input
            v-model.trim="formData.group_key"
            type="text"
            :disabled="isEdit"
            :state="fieldValid('group_key')"
        />
        <b-form-invalid-feedback :state="fieldValid('group_key')">
          {{ formValidation.group_key }}
        </b-form-invalid-feedback>
      </b-form-group>

      <b-form-group label="Display Name">
        <b-form-input
            v-model.trim="formData.display_name"
            type="text"
            :state="fieldValid('display_name')"
        />
        <b-form-invalid-feedback :state="fieldValid('display_name')">
          {{ formValidation.display_name }}
        </b-form-invalid-feedback>
      </b-form-group>

      <b-form-group label="Description">
        <b-form-textarea
            v-model.trim="formData.description"
            rows="3"
            :state="fieldValid('description')"
        />
        <b-form-invalid-feedback :state="fieldValid('description')">
          {{ formValidation.description }}
        </b-form-invalid-feedback>
      </b-form-group>

      <b-form-group label="Sort Order">
        <b-form-input
            v-model="formData.sort_order"
            type="number"
            min="0"
            :state="fieldValid('sort_order')"
        />
        <b-form-invalid-feedback :state="fieldValid('sort_order')">
          {{ formValidation.sort_order }}
        </b-form-invalid-feedback>
      </b-form-group>

      <b-button type="submit" variant="success" :disabled="formState.processing">
        Submit
        <b-spinner v-if="formState.processing" class="ml-1" small/>
      </b-button>
      <b-btn type="button" variant="secondary" @click.prevent="close">Cancel</b-btn>
    </b-form>
  </b-modal>
</template>

<script>
import {API_ROUTES} from "../api";

export default {
  name: "AdminNonMetrcBrowseGroupModal",
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    browseGroup: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      formData: {
        strategy_key: this.browseGroup?.strategy_key ?? "product_family",
        group_key: this.browseGroup?.group_key ?? "",
        display_name: this.browseGroup?.display_name ?? "",
        description: this.browseGroup?.description ?? "",
        sort_order: this.browseGroup?.sort_order ?? 0
      },
      formValidation: {},
      formState: {
        processing: false
      }
    }
  },
  computed: {
    isEdit() {
      return !!this.browseGroup;
    }
  },
  methods: {
    close() {
      this.$root.$emit('bv::hide::modal', 'admin-non-metrc-browse-group-modal');
    },
    fieldValid(field) {
      return typeof this.formValidation[field] !== "undefined" && this.formValidation[field].length > 0 ? false : null;
    },
    applyValidationErrors(data) {
      let validationErrors = {};
      if (typeof data?.errors !== 'undefined') {
        for (let fieldName in data.errors) {
          validationErrors[fieldName] = data.errors[fieldName].join(', ');
        }
      }
      this.formValidation = validationErrors;
    },
    payload() {
      let payload = {
        strategy_key: "product_family",
        display_name: this.formData.display_name,
        description: this.formData.description || null,
        sort_order: this.formData.sort_order === "" ? null : Number(this.formData.sort_order)
      };

      if (!this.isEdit) {
        payload.group_key = this.formData.group_key;
      }

      return payload;
    },
    submitForm() {
      this.formState.processing = true;
      let url = this.isEdit
          ? `${API_ROUTES.ADMIN_NON_METRC_TAXONOMY_BROWSE_GROUPS}/${this.browseGroup.id}`
          : API_ROUTES.ADMIN_NON_METRC_TAXONOMY_BROWSE_GROUPS;

      this.$api.post(url, this.payload()).then(({data}) => {
        this.formValidation = {};
        this.$emit('success', data.browse_group);
        this.close();
      }).catch(error => {
        let data = error.response?.data ?? {};
        this.$bvToast.toast(data.message ?? 'Failed to save browse group', {
          title: 'Error!',
          variant: 'danger'
        });
        this.applyValidationErrors(data);
      }).finally(() => {
        this.formState.processing = false;
      });
    }
  }
}
</script>
